
import { Injectable } from '@angular/core';
import * as moment from 'moment';

import { Subject } from '@shared/DTO/subject';

import { BaseConverter } from '../../base/converters/base-converter.converter';
import { SubjectModel } from '../models/subject.model';
import { ContactConverter } from './contact.converter';
import { ResidenceConverter } from './residence.converter';

@Injectable()
export class SubjectConverter extends BaseConverter<SubjectModel, Subject> {

  private readonly DATE_FORMAT = 'DD/MM/YYYY';

  constructor(public contactConverter: ContactConverter, public residenceConverter: ResidenceConverter) {
    super();
  }

  convertToDto(model: SubjectModel): Subject {
    if (!model) {
      return null;
    }
    return {
      birthCity: model.birthCity,
      birthCountry: model.birthCountry,
      birthDate: model.birthDate ? moment(model.birthDate, this.DATE_FORMAT).format("YYYY-MM-DD") : null,
      birthState: model.birthState,
      citizenship: model.citizenship,
      contacts: this.contactConverter.convertToDtoList(model.contacts),
      residence: this.residenceConverter.convertToDto(model.residence),
      name: model.name,
      surname: model.surname,
      role: model.role,
      taxCode: model.taxCode
    };
  }

  convertToModel(dto: Subject): SubjectModel {
    if (!dto) {
      return null;
    }
    let model: SubjectModel = new SubjectModel();

    model.birthCity = dto.birthCity;
    model.birthCountry = dto.birthCountry;
    model.birthDate = dto.birthDate ? moment(dto.birthDate).format('DD/MM/YYYY') : null;
    model.birthState = dto.birthState;
    model.citizenship = dto.citizenship;
    model.contacts = this.contactConverter.convertToModelList(dto.contacts);
    model.denomination = dto.denomination;
    model.domicile = this.residenceConverter.convertToModel(dto.domicile);
    model.gender = dto.gender;
    model.id = dto.id;
    model.name = dto.name;
    model.office = this.residenceConverter.convertToModel(dto.office);
    model.residence = this.residenceConverter.convertToModel(dto.residence);
    model.role = dto.role;
    model.surname = dto.surname;
    model.taxCode = dto.taxCode;
    model.vat = dto.vat;
    return model;
  }

}
